import React, { useState } from 'react';
import '../styles/ProfilePage.css';

const ProfilePage = () => {
  const [selectedSection, setSelectedSection] = useState('Personal Information');

  const sections = {
    'Personal Information': (
      <div className="profile-content">
        <div className="section-header">
          <button className="edit-button">
            <svg className="edit-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0030B6">
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
            </svg>
            Edit
          </button>
        </div>
        
        <div className="profile-row">
          <div className="profile-picture-section">
            <div className="profile-picture">
              <img src="https://via.placeholder.com/150" alt="Profile" />
            </div>
          </div>
          <div className="profile-section">
            <label>Membership Type:</label>
            <input type="text" value="Life Membership Type" readOnly />
          </div>
          <div className="profile-section">
            <label>Full Name:</label>
            <input type="text" value="Name" />
          </div>
        </div>

        <div className="profile-row">
          <div className="profile-section">
            <label>Certification Name:</label>
            <input type="text" value="Certification" readOnly />
          </div>
          <div className="profile-section">
            <label>Date Of Birth:</label>
            <input type="text" value="01/5/1988" readOnly />
          </div>
          <div className="profile-section">
            <label>E-mail Address:</label>
            <input type="email" value="abcd@gmail.com" />
          </div>
        </div>

        <div className="profile-row">
          <div className="profile-section">
            <label>Mobile Number:</label>
            <input type="text" value="12487452/8745" />
          </div>
          <div className="profile-section">
            <label>Gender:</label>
            <input type="text" value="male" readOnly />
          </div>
        </div>
      </div>
    ),
    'Address': (
      <div className="profile-content">
        <div className="section-header">
          <button className="edit-button">
            <svg className="edit-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0030B6">
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
            </svg>
            Edit
          </button>
        </div>
        
        <div className="section-group">
          <h4>Permanent Address:</h4>
          <div className="field-row">
            <div className="field-group">
              <label>Flat/House NO/Floor/Building:</label>
              <input type="text" value="" className="building-input" />
            </div>
            <div className="field-group">
              <label>Colony/Street/Locality:</label>
              <input type="text" value="" className="locality-input" />
            </div>
            <div className="field-group">
              <label>Landmark:</label>
              <input type="text" value="Your Land Mark" className="landmark-input" />
            </div>
          </div>
          
          <div className="field-row">
            <div className="field-group">
              <label>Country:</label>
              <input type="text" value="" className="country-input" />
            </div>
            <div className="field-group">
              <label>State:</label>
              <input type="text" value="" className="state-input" />
            </div>
            <div className="field-group">
              <label>District:</label>
              <input type="text" value="" className="district-input" />
            </div>
            <div className="field-group">
              <label>Pincode:</label>
              <input type="text" value="" className="pincode-input" />
            </div>
          </div>
        </div>
         <div className="same-as-permanent">
            <input type="checkbox" id="sameAsPermanent" />
            <label htmlFor="sameAsPermanent">Same as Permanent Address</label>
          </div>
        <div className="section-group">
          <h4>Correspondence Address:</h4>
          
          
          <div className="field-row">
            <div className="field-group">
              <label>Flat/House NO/Floor/Building:</label>
              <input type="text" value="" className="building-input" />
            </div>
            <div className="field-group">
              <label>Colony/Street/Locality:</label>
              <input type="text" value="" className="locality-input" />
            </div>
            <div className="field-group">
              <label>Landmark:</label>
              <input type="text" value="Your Land Mark" className="landmark-input" />
            </div>
          </div>
          
          <div className="field-row">
            <div className="field-group">
              <label>Country:</label>
              <input type="text" value="" className="country-input" />
            </div>
            <div className="field-group">
              <label>State:</label>
              <input type="text" value="" className="state-input" />
            </div>
            <div className="field-group">
              <label>District:</label>
              <input type="text" value="" className="district-input" />
            </div>
            <div className="field-group">
              <label>Pincode:</label>
              <input type="text" value="" className="pincode-input" />
            </div>
          </div>
        </div>
      </div>
    ),
    'Academic Details': (
      <div className="profile-content">
        <div className="section-header">
          <button className="edit-button">
            <svg className="edit-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0030B6">
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
            </svg>
            Edit
          </button>
        </div>
        
        <div className="section-group">
          <div className="field-row">
            <div className="field-group">
              <label>Name of Institution:</label>
              <input type="text" value="Institution" />
            </div>
            <div className="field-group">
              <label>Name of Degree:</label>
              <input type="text" value="degree" />
            </div>
            <div className="field-group">
              <label>Name of University:</label>
              <input type="text" value="University" />
            </div>
          </div>
          
          <div className="field-row">
            <div className="field-group">
              <label>Date Of Completion:</label>
              <input type="text" value="Date" />
            </div>
          </div>
        </div>

        <div className="section-group">
          <div className="field-row">
            <div className="field-group">
              <label>Name of Institution:</label>
              <input type="text" value="Institution" />
            </div>
            <div className="field-group">
              <label>Name and place of institution at abroad:</label>
              <input type="text" value="name and place" />
            </div>
            <div className="field-group">
              <label>Name of the Degree:</label>
              <input type="text" value="Degree" />
            </div>
          </div>
          
          <div className="field-row">
            <div className="field-group">
              <label>Specialization:</label>
              <input type="text" value="Specialization" />
            </div>
            <div className="field-group">
              <label>Other Specialization:</label>
              <input type="text" value="specialization" />
            </div>
            <div className="field-group">
              <label>Date Of Completion:</label>
              <input type="text" value="date" />
            </div>
          </div>
        </div>

        <div className="section-group">
          <div className="field-row">
            <div className="field-group">
              <label>Gender:</label>
              <input type="text" value="PHD" />
            </div>
            <div className="field-group">
              <label>Other Qualification:</label>
              <input type="text" value="qualification" />
            </div>
            <div className="field-group">
              <label>Name of Institution:</label>
              <input type="text" value="Institution" />
            </div>
          </div>
          
          <div className="field-row">
            <div className="field-group">
              <label>Research Area:</label>
              <input type="text" value="research area" />
            </div>
            <div className="field-group">
              <label>Date Of Completion:</label>
              <input type="text" value="date" />
            </div>
          </div>
        </div>
      </div>
    ),
    'Uploaded Documents': (
      <div className="profile-content">
        <div className="section-header">
          <button className="edit-button">
            <svg className="edit-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0030B6">
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
            </svg>
            Edit
          </button>
        </div>
        
        <div className="field-row">
          <div className="field-group">
            <label>Internship Certificate:</label>
            <div className="document-value">
              <span className="document-icon">📄</span>
              Abcd File.pdf
            </div>
          </div>
          <div className="field-group">
            <label>Degree Certificate:</label>
            <div className="document-value">
              <span className="document-icon">📄</span>
              Abcd File.pdf
            </div>
          </div>
          <div className="field-group">
            <label>Certificate:</label>
            <div className="document-value">
              <span className="document-icon">📄</span>
              Abcd File.pdf
            </div>
          </div>
        </div>
      </div>
    ),
    'Certificate': (
      <div className="profile-content">
        <div className="section-header">
          <button className="edit-button">
            <svg className="edit-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0030B6">
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
            </svg>
            Edit
          </button>
        </div>
        
        <div className="field-row">
          <div className="field-group">
            <label>Certificate Status:</label>
            <input type="text" value="Active" readOnly />
          </div>
          <div className="field-group">
            <label>Issue Date:</label>
            <input type="text" value="01/01/2011" readOnly />
          </div>
        </div>
      </div>
    ),
    'Renewal': (
      <div className="profile-content">
        <div className="section-header">
          <button className="edit-button">
            <svg className="edit-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0030B6">
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
            </svg>
            Edit
          </button>
        </div>
        
        {/* <div className="section-group">
          <h4>Membership Renewal Guidelines</h4>
          <div className="guidelines-text">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </div>
          
        </div> */}
      </div>
    )
  };

  return (
    <div className="profile-page">
      <section className="hero-fixed">
        <div className="hero-content">
          <h1>All India Occupational Therapists' Association</h1>
        </div>
      </section>

      <div className="scrollable-content">
        <div className="content-container">
          <div className='profile-head'>
            <h1>AIOTA Member Login</h1>
          </div>
          <div className='sidebar-container'>
            <div className="sidebar">
              <ul>
                {Object.keys(sections).map((section) => (
                  <li
                    key={section}
                    onClick={() => setSelectedSection(section)}
                    className={selectedSection === section ? 'active' : ''}
                  >
                    {section}
                  </li>
                ))}
                <li className="sign-out">Sign Out</li>
              </ul>
            </div>            
            <div className="main-content">
              <div className="profile-details-container">
                {sections[selectedSection]}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;